import React from "react";
import useApp from "../../store/app/appContext";
import PageWrapper from '../../containers/app/PageWrapper';
import ScansProvider from '../../store/scans/scansProvider';
import PatientScansList from '../../containers/patients/PatientScansList';

function ScansPage() {
  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
    <ScansProvider>
      <PageWrapper navbar title={'My scans'}>
         {user._id && <PatientScansList patientId={user._id} />}
      </PageWrapper>
    </ScansProvider>
  );
}

export default ScansPage;
